export default "__VITE_ASSET__07e2d61b__"